<script setup lang="ts">
// Shell is deliberately empty — each view owns its own chrome. AppView and
// AdminView render TopBar; Landing renders none. The three framework roots
// (dialogs, toasts, context menus) are mounted here once for the whole app;
// leaf components spawn via openDialog/toast.*/openMenu.
// See docs/framework/ui/README.md § The three roots.

import { watch } from 'vue'

import ChangePasswordDialog from './components/ChangePasswordDialog.vue'
import { useAuth } from './composables/useAuth'
import ContextMenuLayer from './ui/components/ContextMenuLayer.vue'
import DialogRoot       from './ui/components/DialogRoot.vue'
import ToastLayer       from './ui/components/ToastLayer.vue'
import { openDialog }   from './ui/dialogs'

// First-login forced password change. When Firestore flips mustChangePassword
// true (via the useAuth snapshot listener) we open the forced dialog once,
// non-dismissible; the dialog itself watches for the flag flipping back false
// so it auto-closes on success or on an external clear from another tab.
// Lives here rather than in TopBar so it survives route changes and does not
// depend on which view is mounted.
const { mustChangePassword } = useAuth()
let forcedOpen = false

watch(mustChangePassword, async (must) => {
  if (!must || forcedOpen) return
  forcedOpen = true
  try {
    await openDialog(ChangePasswordDialog, { mode: 'forced' }, { dismissible: false })
  } finally {
    forcedOpen = false
  }
}, { immediate: true })
</script>

<template>
  <RouterView />
  <DialogRoot />
  <ToastLayer />
  <ContextMenuLayer />
</template>
